import { pharmacyInventoryApi } from "@/core/inventory/inventory-api";
import {
  addPrescriptionLine,
  ensureDemoClinicalData,
  listPrescriptions,
} from "@/core/clinical/clinical-store";
import { IAM_TENANT_SLUG } from "@/core/config";
import { isDemoModeEnabled } from "@/core/demo/is-demo-mode-enabled";
import { loadStoredSession } from "@itaas/core/auth/auth.storage";

const BIND_KEY = "hospitol.clinical.iscBound";

/** SKU seed ISC demo-hospitol — Paracétamol officine + Infliximab (accord préalable). */
const DEMO_RX_SKUS = ["SKU-MED-003", "MED-003", "SKU-MED-010", "MED-010"];

/**
 * Lie la consultation démo à un médicament réel du dépôt WH-PHARMA (après seed ISC).
 * Permet au médecin d'envoyer l'ordonnance sans saisie manuelle au premier test.
 */
export async function bindDemoPrescriptionToIscProducts(): Promise<void> {
  if (!isDemoModeEnabled()) return;
  const tenantSlug = loadStoredSession()?.tenant?.slug ?? IAM_TENANT_SLUG;
  if (tenantSlug !== "demo-hospitol") return;
  if (localStorage.getItem(BIND_KEY)) return;

  ensureDemoClinicalData();

  try {
    const products = await pharmacyInventoryApi.listPharmacyProducts();
    const match =
      products.find((p) => DEMO_RX_SKUS.includes(p.sku) || DEMO_RX_SKUS.includes(p.code)) ??
      products.find((p) => p.label.toLowerCase().includes("paracétamol"));

    if (!match) return;

    const prescription = listPrescriptions()[0];
    if (!prescription) return;

    if (prescription.lines.length === 0) {
      addPrescriptionLine(prescription.id, {
        productId: match.id,
        productLabel: match.label,
        quantity: 1,
        frequency: "thrice_daily",
        durationDays: 5,
        timing: ["morning", "noon", "evening"],
        instructions: "1 cp à chaque prise",
      });
    }

    localStorage.setItem(BIND_KEY, new Date().toISOString());
  } catch {
    /* ISC offline — nouvel essai au prochain chargement */
  }
}

export function resetDemoClinicalIscBind(): void {
  localStorage.removeItem(BIND_KEY);
}
